import { Component, input } from '@angular/core';
import { DocumentFileSignedUrlPipe } from '../../pipes/document-file-signed-url-pipe';
import { FileResponse } from '../../../../core/clients/omni-core/models';

@Component({
  selector: 'app-document-download-button',
  imports: [DocumentFileSignedUrlPipe],
  templateUrl: './document-download-button.html',
})
export class DocumentDownloadButton {
  document = input.required<FileResponse>();
  organizationID = input.required<string>();
}
